export enum TasksSubTab {
  EQUIP_STAFF = 'equip-staff',
  PATIENT_AND_SUPPORTS = 'patient-and-supports',
}
